"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Renderer {
    constructor(stage) {
        this.stage = stage;
        this._defaultShader = undefined;
    }
    gc(aggressive) {
        // Noop
    }
    getDefaultShader(context = this.stage.context) {
        if (!this._defaultShader) {
            this._defaultShader = this._createDefaultShader(context);
        }
        return this._defaultShader;
    }
    isValidShaderType(shaderType) {
        return shaderType.prototype instanceof this._getShaderBaseType();
    }
    getSupportedShaderType(shaderType) {
        if (!this.isValidShaderType(shaderType)) {
            const convertedShaderType = this._getShaderAlternative(shaderType);
            if (!convertedShaderType) {
                return undefined;
            }
            return convertedShaderType;
        }
        else {
            return shaderType;
        }
    }
    _getShaderAlternative(shaderType) {
        return undefined;
    }
    onResizeCanvasSize() {
        // Not implemented.
    }
}
exports.Renderer = Renderer;
//# sourceMappingURL=Renderer.js.map